var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSettings2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 23 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.675585, 2.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: 1.5678,
    x2: 22.9998469,
    y2: 1.49781357,
    id: "Stroke-5-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1.5678,
    x2: 3.5,
    y2: 1.5,
    id: "Stroke-5-Copy-3",
    transform: "translate(2.500000, 2.032807) rotate(1.553481) translate(-2.500000, -2.032807) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.5,
    cy: 1.5,
    r: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 14.5678,
    x2: 6.5,
    y2: 14.5,
    id: "Stroke-5",
    transform: "translate(4.000000, 14.067800) rotate(0.706265) translate(-4.000000, -14.067800) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 14.5,
    x2: 22.9998469,
    y2: 14.4978136,
    id: "Stroke-5-Copy"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.5,
    cy: 14.5,
    r: 2.25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 8.5678,
    x2: 16.9998469,
    y2: 8.49781357,
    id: "Stroke-5-Copy",
    transform: "translate(9.000000, 8.532807) scale(-1, 1) translate(-9.000000, -8.532807) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8.5678,
    x2: 22.5,
    y2: 8.5,
    id: "Stroke-5-Copy-2",
    transform: "translate(21.500000, 9.032807) scale(-1, 1) rotate(1.553481) translate(-21.500000, -9.032807) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    transform: "translate(18.500000, 8.500000) scale(-1, 1) translate(-18.500000, -8.500000) ",
    cx: 18.5,
    cy: 8.5,
    r: 2.25
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings_2.fb54fbce.svg";
export { ForwardRef as ReactComponent };